// In LimitDialog.js - Update the Dialog component
import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Button,
  useMediaQuery,
  Typography,
  Box,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import UsageBox from "./UsageBox";
import PricesSection from "../PricesSection";

const LimitDialog = ({
  open,
  onClose,
  userId,
  isImageLimit,
  isLessonLimit,
  resetTime,
  styles,
  user,
  titleText = "Daglig användning uppnådd",
  accountType,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [showSchoolPlans, setShowSchoolPlans] = useState(false);

  // Calculate dynamic max width based on plan type
  const getMaxWidth = () => {
    if (isMobile) return "100%";
    return showSchoolPlans ? 1300 : 670; // Wider for school plans
  };

  const getMessage = () => {
    if (isImageLimit && isLessonLimit) {
      return "Du har nu nått den dagliga gränsen för både lektioner och bilder.";
    } else if (isImageLimit) {
      return "Du har nu nått den dagliga gränsen för bilder.";
    } else if (isLessonLimit) {
      return "Du har nu nått den dagliga gränsen för lektioner.";
    }
    return "";
  };

  const getTimeRemaining = () => {
    if (!resetTime) return "";
    const now = Date.now();
    const diffMs = resetTime - now;
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    if (diffHours >= 1) {
      return `om ${diffHours} ${diffHours === 1 ? "timme" : "timmar"}${
        diffMinutes > 0
          ? ` och ${diffMinutes} ${diffMinutes === 1 ? "minut" : "minuter"}`
          : ""
      }`;
    }
    return `om ${diffMinutes} ${diffMinutes === 1 ? "minut" : "minuter"}`;
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      fullScreen={isMobile}
      maxWidth={false}
      PaperProps={{
        sx: {
          borderRadius: isMobile ? 0 : 2,
          maxWidth: getMaxWidth(),
          p: { xs: 0, md: 3 },
          pt: { xs: 0, md: 0 },
          position: "relative",
          pb: 0,
          transition: "max-width 0.3s ease", // Smooth transition
          height: isMobile ? "89vh" : "auto",
          maxHeight: isMobile ? "100vh" : "90vh",
        },
      }}
    >
      <DialogTitle sx={{}}>
        <Box
          sx={{ position: "absolute", right: 12, top: 12, cursor: "pointer" }}
          onClick={onClose}
        >
          <CloseIcon />
        </Box>
        <Typography
          variant="h6"
          component="div"
          sx={{
            fontWeight: 700,
            fontSize: { xs: "1.1rem", md: "2rem" },
            textAlign: "center",
            // backgroundClip: "text",
            // textFillColor: "transparent",
            // background: "linear-gradient(135deg, #43CBFF 10%, #9708CC 100%)",
            // WebkitBackgroundClip: "text",
            // WebkitTextFillColor: "transparent",
          }}
        >
          {titleText}
        </Typography>

        {!showSchoolPlans && (
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 500,
              fontSize: { xs: "0.8rem", md: "1rem" },
              textAlign: "center",
              color: "text.secondary",
              margin: "0 auto",
              mt: 1,
              width: { xs: "100%", md: showSchoolPlans ? "450px" : "80%" },
            }}
          >
            {isImageLimit
              ? "Du har nått din månatliga gräns på 50 bilder för premium-användare. Kontakta info@studera.ai om du vill kunna generera fler."
              : "Du använder ett gratiskonto med daglig begränsning. Uppgradera för full åtkomst. Vänligen välj en plan:"}
          </Typography>
        )}
      </DialogTitle>
      <DialogContent
        sx={{ p: { xs: 0, md: 2 }, display: isImageLimit ? "none" : "block" }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            mb: 4,
            mt: 0,
          }}
        >
          <Box sx={{ width: "100%" }}>
            <PricesSection
              hideBasic={false}
              strikeThrough={true}
              user={user}
              accountType={accountType}
              styles={styles}
              showSchoolPlans={showSchoolPlans}
              setShowSchoolPlans={setShowSchoolPlans}
            />
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default LimitDialog;
